import { render, staticRenderFns } from "./warehouseDemandInfo.vue?vue&type=template&id=5a10e8c8&scoped=true&"
import script from "./warehouseDemandInfo.vue?vue&type=script&lang=js&"
export * from "./warehouseDemandInfo.vue?vue&type=script&lang=js&"
import style0 from "./warehouseDemandInfo.vue?vue&type=style&index=0&id=5a10e8c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a10e8c8",
  null
  
)

export default component.exports